import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect, useSelector } from 'react-redux';
import { withRouter, useParams, useLocation } from "react-router";
import "./InvoiceSettingsContainer.less";
import { getSellerInvoiceItemTypesList, 
  toggleInvoiceItemTypeDefault, 
  getCategoryItemTypeList,
  addInvoiceItemType,
  deleteInvoiceItemType
 } from "../../../services/Seller";
import {
  Loader,
  Dimmer,
  Segment,
  Header,
  Icon,
  Table,
  Checkbox,
  Button,
  Modal,
  Dropdown,
  Form,
  Confirm
} from "semantic-ui-react";
import closeIcon from '../../../assets/images/newui/close.png';
import DGTextbox from "../../../components/FormControls/Textbox/DGTextbox";
import Formsy from 'formsy-react';
import GeneralMessage from '../../../components/GeneralMessage/GeneralMessage';

function InvoiceSettingsContainer({history}) {
  const params = useParams();

  const [sellerInvoiceItemTypeList, setSellerInvoiceItemTypeList] = useState(
    []
  );
  const [categoryItemTypeList, setCategoryItemTypeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [invoiceItemTypeDropdownKey,setInvoiceItemTypeDropdownKey] = useState(0);
  const [errorInItemTypeSelection,setErrorInItemTypeSelection] = useState(false);
  const [selectedInvoiceItemType,setSelectedInvoiceItemType] = useState(undefined);
  const [rate,setRate] = useState(0);
  const [isInvoiceItemAddModalOpen,setIsInvoiceItemAddModalOpen] = useState(false);
  const [errorInRateInput,setErrorInRateInput] = useState(false);
  const [invoiceItemTypeAddErrorMessage,setInvoiceItemTypeAddErrorMessage] = useState("");
  const [actionsErrorMessage,setActionsErrorMessage] = useState("");
  const [selectedInvoiceItemForDelete, setSelectedInvoiceItemForDelete] = useState(undefined);
  const [showDeleteConfirmationDialog, setDeleteShowConfirmationDialog] = useState(false);
  const [deleteConfirmationDialogContent, setDeleteConfirmationDialogContent] = useState("");
  const [isDefaultValue, setIsDefaultValue] = useState(true);
  const location = useLocation();
  const [isReferred, setIsReferred] = useState(false)

  const activeSubsCount = useSelector(({ seller }) => seller.activeSubscriptionsCount);

  useEffect(() => {
    loadData();
    loadCategoryItemTypeData();
    if(location.state?.referrer == 'cp'){
      setIsReferred(true);
    }
  }, []);

  const loadData = async () => {
    setLoading(true);
    let res = await getSellerInvoiceItemTypesList();
    if (res.resStatus == 200) {
      setSellerInvoiceItemTypeList(res.data);
    }
    setLoading(false);
  };

  const loadCategoryItemTypeData = async () => {
    let res = await getCategoryItemTypeList();
    if (res.resStatus == 200) {
      setCategoryItemTypeList(res.data);
    }
  };
  const handleIsDefaultCheck = async (scsInvoiceItemTypeID,data) => {

    setActionsErrorMessage("");
    // check, atleast one default is available
    if(data.checked == false)
    {
      let isDefaultCount = sellerInvoiceItemTypeList.filter((item) => {return item.isDefault == true}).length;
      if(isDefaultCount <= 1)
      {
        setActionsErrorMessage("At least one of the items should be marked default.");
        setTimeout(() => {
          setActionsErrorMessage("");
        }, 3500);
        return;
      }
    }

    let res = await toggleInvoiceItemTypeDefault(scsInvoiceItemTypeID)
    if(res.resStatus == 200)
    {
      let invoiceItemTypeIndex = sellerInvoiceItemTypeList.findIndex((item) => {return item.scsInvoiceItemTypeID == scsInvoiceItemTypeID})
      if(invoiceItemTypeIndex != -1)
      {
        sellerInvoiceItemTypeList[invoiceItemTypeIndex].isDefault = !sellerInvoiceItemTypeList[invoiceItemTypeIndex].isDefault;
        setSellerInvoiceItemTypeList([...sellerInvoiceItemTypeList]);
      }
    }else
    {
      setActionsErrorMessage(res.message);
      setTimeout(() => {
        setActionsErrorMessage("");
      }, 3500);
    }
  }
  
  const onSellerInvoiceItemTypeSelectionChange = (data) => {
    
    if(data && data.value)
    {
      setSelectedInvoiceItemType(data.value);
      setErrorInItemTypeSelection(false);
    }  
  }

  const onInvalidInvoiceItemAddSubmit = () => {
    if(selectedInvoiceItemType == undefined)
    {
      setErrorInItemTypeSelection(true) 
    }
  }

  const onInvoiceItemAddSubmit = async (form) =>{
    try {
        let InValidForm = false;
        if(selectedInvoiceItemType == undefined)
        {
          setErrorInItemTypeSelection(true) 
          InValidForm = true;
        }
        
        if(_.isEmpty(rate))
        {
          setErrorInRateInput(true);
          InValidForm = true;
        }
          
        if(InValidForm)
        {
            return;    
        }

        let res =  await addInvoiceItemType(selectedInvoiceItemType,rate,isDefaultValue);
        if(res.resStatus == 200)
        {
          resetInvoiceItemAddForm();
          loadData();
          setIsInvoiceItemAddModalOpen(false);
        }else
        {
          setInvoiceItemTypeAddErrorMessage(res.message);
        }
    }
    catch (ex) { 
        console.log(ex);
    }
  }

  const resetInvoiceItemAddForm = () => {
    setSelectedInvoiceItemType(undefined);
    setRate(0);
  }

  const onRateKeyDown = (evt) => {
    if (evt.key != 'Backspace' && evt.key != 'Delete' && evt.key != 'Tab') {
        var patt = new RegExp(/^[0-9.\b]+$/);
        var res = patt.test(evt.key);
        if (!res){
          evt.preventDefault();
          return;
        }

        patt = new RegExp(/^\d*(\.\d{0,2})?$/);
        let value = evt.target.value+""+evt.key;
        res = patt.test(value);
        if(!res)
        {
          evt.preventDefault();
          return;
        }
    }
  }

  const handleRateChange = (e) => {
    setRate(e.target.value)
    setErrorInRateInput(false)
  }

  const handleInvoiceItemDeleteClick = (invoiceItemType) => {

      let defaultCount = sellerInvoiceItemTypeList.filter((item) => {return item.isDefault == true &&  item.scsInvoiceItemTypeID != invoiceItemType.scsInvoiceItemTypeID}).length;
      if(defaultCount < 1)
      {
        setActionsErrorMessage("At least one of the items should be marked default.");
        setTimeout(() => {
          setActionsErrorMessage("");
        }, 3500);
        return;
      }
    
      setDeleteConfirmationDialogContent(`Do you want to to delete the “${invoiceItemType.displayName}” ?`)
      setSelectedInvoiceItemForDelete(invoiceItemType);
      setDeleteShowConfirmationDialog(true);
  }

  const onCloseDeleteConfirmation = () => {
    setSelectedInvoiceItemForDelete(undefined);
    setDeleteShowConfirmationDialog(false);
  }

  const onDeleteConfirmation = async () => {
    if(selectedInvoiceItemForDelete && selectedInvoiceItemForDelete.scsInvoiceItemTypeID)
    {
      let res = await deleteInvoiceItemType(selectedInvoiceItemForDelete.scsInvoiceItemTypeID);
      if(res.resStatus == 200)
      {
        loadData();
        setSelectedInvoiceItemForDelete(undefined);
        setDeleteShowConfirmationDialog(false);
      }else
      {
        setActionsErrorMessage(res.message);
        setTimeout(() => {
          setActionsErrorMessage("");
        }, 3500);
        setSelectedInvoiceItemForDelete(undefined);
        setDeleteShowConfirmationDialog(false);
      }
    }
  }

  const handleIsDefaultValue = (data) => {
    setIsDefaultValue(data.checked);
  }

  const onDoneClick = () => {
    history.push('/')
  }

  return (
    <>
    {isReferred && <div className="pricing-setting-msg"><div>Please update your pricing.</div><div>This pricing is only visible to you and is not shown to your customers until you send it to them.</div></div> }
    <div className="invoice-settings-container">
      {loading ? (
        <Dimmer active>
          <Loader indeterminate size="massive" />
        </Dimmer>
      ) : (
        ""
      )}
      <Segment.Group>
        <Segment size="massive" className="no-radius">
          <Header as="h1">
            <Header.Content>
              <Icon name="list" size="small" />
                My Pricing
                <Button onClick={() => {setIsInvoiceItemAddModalOpen(true)}} primary className={"add-item-button"}>
                      + Add
                </Button>
            </Header.Content>
          </Header>
        </Segment>
      </Segment.Group>
      {
        <>
       
        <div className={"invoice-item-type-table-container"}>
          {
            actionsErrorMessage && actionsErrorMessage.length > 0 &&
            <GeneralMessage type="error" message={actionsErrorMessage} />
          }
             
          <Table className={"invoice-item-type-table"}>
            {
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={5}>Name</Table.HeaderCell>
                  <Table.HeaderCell width={1} textAlign={"right"}>Rate</Table.HeaderCell>
                  <Table.HeaderCell width={2} textAlign={"right"}>Default</Table.HeaderCell>
                  <Table.HeaderCell width={1}></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
            }
            {sellerInvoiceItemTypeList && sellerInvoiceItemTypeList.length > 0 ? (
              <>
                <Table.Body>
                  {sellerInvoiceItemTypeList.map((invoiceItemType) => {
                    return (
                      <>
                        <Table.Row className={"item-row"}>
                          <Table.Cell>{invoiceItemType.displayName } {activeSubsCount > 1 ? <><br></br><span className={"invoice-item-category-name table"}> ({invoiceItemType.categoryName}) </span></>: ""}</Table.Cell>
                          <Table.Cell textAlign={"right"}>$ {Math.floor(invoiceItemType.rate)}</Table.Cell>
                          <Table.Cell textAlign={"right"}>
                            {
                             <Checkbox 
                                 className={"is-default-toggle-table"}
                                 toggle
                                 onChange={(e,data) => handleIsDefaultCheck(invoiceItemType.scsInvoiceItemTypeID,data)}
                                 checked={invoiceItemType.isDefault} />
                            }
                          </Table.Cell>
                          <Table.Cell textAlign={"right"}>
                            <Dropdown direction={"left"} icon={"ellipsis vertical"}>
                              <Dropdown.Menu>
                                <Dropdown.Item onClick={() => {
                                  handleInvoiceItemDeleteClick(invoiceItemType)
                                }} 
                                className={"delete-menu-item"} icon={<Icon color={"red"} name={"trash"}/>}  text='Delete' />
                              </Dropdown.Menu>
                            </Dropdown>
                          </Table.Cell>
                        </Table.Row>
                      </>
                    );
                  })}
                </Table.Body>
              </>
            ) : (
              <Table.Body>
                <Table.Row>
                  <Table.Cell>{"Invoice Items Type Not Available"}</Table.Cell>
                </Table.Row>
              </Table.Body>
            )}
          </Table>
        </div>
        </>
      }

      <Modal
        open={isInvoiceItemAddModalOpen}
        closeOnDimmerClick={false}
        className="invoice-item-type-add-modal"
      >
        <div className="header">
          <div
            className="close-button"
            onClick={() => setIsInvoiceItemAddModalOpen(false)}
          >
            <img src={closeIcon}></img>
          </div>
          <div className="main-heading">{ "New Invoice Item"} </div>
        </div>
  
        <div className={"model-body"}>
          {
            invoiceItemTypeAddErrorMessage && invoiceItemTypeAddErrorMessage.length > 0 && 
            <GeneralMessage type="error" message={invoiceItemTypeAddErrorMessage}/>
          }
        <Formsy  
            className={"invoice-item-type-form"} 
            onValidSubmit={onInvoiceItemAddSubmit} 
            onInvalidSubmit={onInvalidInvoiceItemAddSubmit}>
          <Form.Dropdown 
            key={`invoice-item-type-dropdown-key-${invoiceItemTypeDropdownKey}`}
            options={categoryItemTypeList.map((item) => {return {
              id: item.scCategoryInvoiceItemTypeID,
              value: item.scCategoryInvoiceItemTypeID,
              text: <div>
                <span>
                  {item.displayName}
                </span>
                {
                  activeSubsCount > 1 ? 
                  <span className={"invoice-item-category-name"}>
                    ({item.categoryName})
                  </span>
                  : ""
                }    
              </div>
            }})}
            validationErrors={{
              isDefaultRequiredValue: 'Invoice item type is required',
            }}
            required
            value={selectedInvoiceItemType}
            deburr={true}
            direction={"left"}
            selectOnBlur={false}
            selection
            fluid
            placeholder="Select Invoice Item Type"
            label="Invoice Item Type"
            className={"multi-select invoive-item-type-dropdown"}
            error={errorInItemTypeSelection}
            onChange={(e,data) => {
              onSellerInvoiceItemTypeSelectionChange(data)
            }}> 
          </Form.Dropdown >
          {errorInItemTypeSelection &&
              <div className="error-label" >
                 Invoice item type is required
              </div>
          }  
          <DGTextbox 
            novalidate
            name="rate"
            label="Rate" 
            placeholder="Rate" 
            required 
            step={0.01}
            maxLength={4}
            type="number"
            tabIndex={2}
            validationErrors={{
                isDefaultRequiredValue: 'This field is required',
            }}
            onChange={(e) => handleRateChange(e)}
            onKeyDown={(e) => onRateKeyDown(e)}
            className={ errorInRateInput ? "error" : ""}
            value={rate}
          />
          {errorInRateInput &&
              <div className="error-label rate" >
                 Rate is required
              </div>
          }
          <div className={"is-default-checkbox-container"}>
            <Checkbox 
              label={"Mark as default"}
              slider
              toggle
              onChange={(e,data) => {handleIsDefaultValue(data)}}
              checked={isDefaultValue} /> 
          </div>
        
          <div className="btn-container">
            <Button
              formNoValidate
              type="submit"
              className="button-submit"
            >
               {"Add"}
            </Button>
          </div>
          </Formsy>
        </div>
      </Modal>

      <Confirm
          closeOnDimmerClick={false} 
          className='invoice-delete-confirmation-dialog'
          header='Confirm'
          open={showDeleteConfirmationDialog}
          content={deleteConfirmationDialogContent}
          onCancel={() => {onCloseDeleteConfirmation()}}
          onConfirm={() => {onDeleteConfirmation()}} 
          confirmButton="Yes, Delete"
          cancelButton="No"
          />

      {isReferred && <div className="next-button-container">
                <button className='invoice-submit-btn' type='button' onClick={onDoneClick}>DONE</button>
        </div>}
    </div>
    </>
  );
}

export default withRouter(InvoiceSettingsContainer);
